import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { TipoDocumento } from '../models/digital-client/TipoDocumento';
import { ResponseBase } from '../models/ResponseBase';
import { Departamento } from '../models/digital-client/Departamento';
import { Municipio } from '../models/digital-client/Municipio';
import { ValidatePersonRiskRequest } from '../models/digital-client/ValidatePersonRisk';
import { TipoGenero } from '../models/digital-client/TipoGenero';
import { EstadoCivil } from '../models/digital-client/EstadoCivil';
import { ActividadEconomica } from '../models/digital-client/ActividadEconomica';
import { TipoOcupacion } from '../models/digital-client/TipoOcupacion';
import { TipoMoneda } from '../models/digital-client/TipoMoneda';
import { Pais } from '../models/digital-client/Pais';
import { FindUser } from '../models/digital-client/FindUser';
import { FindPersonFuccById } from '../models/digital-client/FindPersonFuccById';
import { ClsPersona } from '../models/digital-client/ClsPersona';

@Injectable({
  providedIn: 'root',
})
export class DigitalClientService {
  urlDigitalClient: string = environment.UrlServices.API_DigitalClient;

  constructor(private http: HttpClient) {}

  GetTiposDocumento(): Observable<ResponseBase<TipoDocumento[]>> {
    return this.http.get<ResponseBase<TipoDocumento[]>>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetTiposDocumento`
    );
  }

  FindUser(
    tipoDocumento: string,
    nroDocumento: string,
    primerApellido: string
  ): Observable<ResponseBase<FindUser>> {
    return this.http.get<ResponseBase<FindUser>>(`${this.urlDigitalClient}/api/ClienteDigital/FindUser?InId_Aplicacion=13&InTipoDocumento=${tipoDocumento}&StrNroDocumento=${nroDocumento}&StrPrimerApellido=${primerApellido}&InIdPersona=0&CrTipoPersona=A&InCodRamo=0`);
  }

  FindPersonFuccById(
    inIdPersona: string,
  ): Observable<ResponseBase<FindPersonFuccById>> {
    return this.http.get<ResponseBase<FindPersonFuccById>>(`${this.urlDigitalClient}/api/ClienteDigital/FindPersonFuccById?InIdPersona=${inIdPersona}`);
  }

  GetTiposDocumentoConParametro(intypePerson: number): Observable<ResponseBase<TipoDocumento[]>> {
    return this.http.get<ResponseBase<TipoDocumento[]>>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetTiposDocumento?IntypePerson=${intypePerson}`
    );
  }

  GetMunicipiosByDepartamentos(): Observable<ResponseBase<Municipio[]>> {
    return this.http.get<any>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetMunicipiosByDepartamentos`
    );
  }

  GetMunicipiosPorDepartamento(seek: string): Observable<any> {
    return this.http.get<any>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetMunicipiosByDepartamentos?InCodDpto=${seek}`
    );
  }

  GetDepartamentosByPais(): Observable<ResponseBase<Departamento[]>> {
    return this.http.get<any>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetDepartamentosByPais?InCodPais=1`
    );
  }

  GetTiposGeneros(): Observable<ResponseBase<TipoGenero[]>> {
    return this.http.get<ResponseBase<TipoGenero[]>>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetTiposGeneros`
    );
  }

  GetEstadosCivil(): Observable<ResponseBase<EstadoCivil[]>> {
    return this.http.get<ResponseBase<EstadoCivil[]>>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetEstadosCivil`
    );
  }

  GetActivadesEconomicas(): Observable<ResponseBase<ActividadEconomica[]>> {
    return this.http.get<ResponseBase<ActividadEconomica[]>>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetActivadesEconomicas`
    );
  }

  GetTiposOcupacion(): Observable<ResponseBase<TipoOcupacion[]>> {
    return this.http.get<ResponseBase<TipoOcupacion[]>>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetTiposOcupacion`
    );
  }

  GetPaises(): Observable<ResponseBase<Pais[]>> {
    return this.http.get<ResponseBase<Pais[]>>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetPaises`
    );
  }

  GetTiposMonedas(): Observable<ResponseBase<TipoMoneda[]>> {
    return this.http.get<ResponseBase<TipoMoneda[]>>(
      `${this.urlDigitalClient}/api/Parametrizacion/GetTiposMonedas`
    );
  }

  GetTipoAsociado(): Observable<any> {
    return this.http.get<any>(
      `${this.urlDigitalClient}/api/Gobernabilidad/GetTipoAsociado`
    );
  }
  
  ValidatePersonRisk(personRisk: ValidatePersonRiskRequest): Observable<ResponseBase<boolean>> {
    return this.http.post<any>(
      `${this.urlDigitalClient}/api/ClienteDigital/ValidatePersonRisk`,personRisk
    );
  }

  CreatePerson(persona: ClsPersona): Observable<ResponseBase<any>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  
    return this.http.post<ResponseBase<any>>(
      `${this.urlDigitalClient}/api/ClienteDigital/CreatePerson`,
      persona,
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('Error en CreatePerson:', error);
        return throwError(() => new Error('Error al crear la persona.'));
      })
    );
  }

  getPersonData(inIdPersona: number): Observable<any> {
    return this.http.get<any>(`${this.urlDigitalClient}/api/ClienteDigital/FindPersonFuccById?inIdPersona=${inIdPersona}`);
  }
  
}

